import React, { useState } from 'react';

import { ErrorArea, Form, Input, ReformSubmitHandler, Submit } from '@kodkafa/reform';

import {
  RecoveryDto,
  useAuthControllerRecoveryMutation,
  useVerificationControllerVerifyMutation,
  VerifyDto,
} from '@/store/services/MidleNestApi.service';
import { Link, useNavigate } from 'react-router-dom';
import { errorHandler } from '@/utils/error.handler';
import { clearEmptyProperties } from '@/utils/clear-empty-properties.util';
import { useTranslation } from 'react-i18next';
import { storageLocal } from '@/utils';

export default function RecoveryView() {
  const { t } = useTranslation();
  const [data, setData] = useState(sessionStorage.getItem('recovery') || '');
  const [mutation] = useAuthControllerRecoveryMutation();
  const [verify] = useVerificationControllerVerifyMutation();
  const navigate = useNavigate();

  const handleRecovery: ReformSubmitHandler<{ data: string }> = async (data, setError) => {
    const [email, phone] = [
      data.data.match(/@/) && data.data,
      !data.data.match(/@/) ? data.data : null,
    ];
    await mutation(clearEmptyProperties<RecoveryDto>({ email, phone }))
      .unwrap()
      .then(() => {
        setData(data.data);
        sessionStorage.setItem('recovery', data.data);
        gtag('event', 'recovery', { identity: data.data });
      })
      .catch((error) => errorHandler(error, setError));
  };
  const handleVerify: ReformSubmitHandler<VerifyDto> = async (data, setError) => {
    await verify(data)
      .unwrap()
      .then((payload) => {
        if (payload) {
          sessionStorage.removeItem('recovery');
          storageLocal.setItem('accessToken', payload.token);
          gtag('event', 'recovery-verify', { identity: data.data });
          navigate('/reset');
        }
      })
      .catch((error) => errorHandler(error, setError));
  };

  return (
    <div className='flex flex-col py-8 mx-auto w-96 text-sm'>
      <h1 className='text-xl font-bold mb-6 text-center'>{t('Reset Your Password')}</h1>

      {!data ? (
        <Form onSubmit={handleRecovery} defaultValues={{ data }} className='flex !gap-4'>
          <div>
            <Input
              name='data'
              label={t('Email address')}
              placeholder={t('jon@doe.com')}
              className='w-full'
            />
          </div>

          <p className='text-xs text-gray-700 text-center'>
            {t('We`ll send a recovery code via email.')}
          </p>
          <ErrorArea />
          <div>
            <Submit>{t('Sent a recovery code')}</Submit>
          </div>
        </Form>
      ) : (
        <Form onSubmit={handleVerify} defaultValues={{ data }} className='flex !gap-4'>
          <div>
            <Input
              name='data'
              label={t('Email address')}
              placeholder={t('jon@doe.com')}
              className='w-full'
              readOnly
            />
            <p className='text-right'>
              <button className='text-xs' onClick={() => setData('')}>
                {t('Change the email!')}
              </button>
            </p>
          </div>

          <div>
            <Input name='code' label={t('Code')} placeholder={t('ABCDE')} className='w-full' />
            <Input name='type' value='recovery' type='hidden' />
          </div>
          <ErrorArea />
          <div>
            <Submit>{t('Submit')}</Submit>
          </div>
        </Form>
      )}
      <hr className='my-4 border-t' />
      <p className='text-center'>
        {t('Already have an account?')}
        <Link to='/login' className='font-bold'>
          {t('Login')}
        </Link>
      </p>
    </div>
  );
}
